import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FaLinkedin } from "react-icons/fa";
import "./Footer.css"; // Import custom styles
import FooterLogo from "../images/brands/footer-logo.png";
import { HashLink } from 'react-router-hash-link';


const Footer = () => {
  return (
    <footer className="footer py-5 px-3">
      <div className="container">
        <div className='row gy-4'>
          <div className='col-lg-3 col-md-6'>
            <div className="footer-logo">
              <div className="footer-logo">
                <img src={FooterLogo} alt="Premier Logo" />
              </div>
              <p className="footer-copyright">
                PREMIER VACUUM SYSTEMS LLC<br /> P.O.Box 1094, Gadsden, AL 35902, <br /> Work: 5902 Bulff Road, Boaz, AL 35956 - USA.
              </p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-12'>
            <div className="footer-products">
              <h5 className="footer-heading">Products</h5>
              <div className="d-flex justify-content-between">
                <ul className="footer-links">
                  <li><Link to="/product-details/pv">PV Series</Link></li>
                  <li><Link to="/product-details/premier">PREMIER SERIES</Link></li>
                  <li><Link to="/product-details/ps">PS Series</Link></li>
                  <li><Link to="/product-details/pxl">PXL Series</Link></li>
                  <li><Link to="/product-details/p2be">P2BE Series</Link></li>
                  <li><Link to="/product-details/p501">P501 Series</Link></li>
                  <li><Link to="/product-details/pws">PWS Series</Link></li>
                </ul>
                <ul className="footer-links">
                  <li><Link to="/product-details/pa">PA Series</Link></li>
                  <li><Link to="/product-details/pat">PAT Series</Link></li>
                  <li><Link to="/product-details/pshr">PSHR Series</Link></li>
                  <li><Link to="/product-details/ptc">PTC Series</Link></li>
                  <li><Link to="/product-details/plh">PLH Series</Link></li>
                  <li><Link to="/product-details/wxp">WXP Series</Link></li>
                  <li><Link to="/product-details/p9000">P9000</Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className='col-lg-2 col-md-3 col-6 d-flex justify-content-md-center justify-content-start'>
            {/* <div className="footer-company">
              <h5 className="footer-heading">Company</h5>
              <ul className="footer-links">
                <li><Link to="/about-us">Our Story</Link></li>
                <li>
                  <Link to="/sales-partners">Sales Partners</Link>
                </li>
                <HashLink smooth to="/#services" className="nav-link mb-1">
                  Services
                </HashLink>
                <HashLink smooth to="/#in-house-facility" className="nav-link mb-1">
                  In-House Facilities
                </HashLink>
                <li>
                  <Link
                    to="/contact-us"
                    onClick={() => {
                      if (window.location.pathname === "/contact-us") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Contact Us
                  </Link>
                </li>
                <li><Link to="/careers">Careers</Link></li>

                <li><Link to="/news">News</Link></li>
              </ul>
            </div> */}
            <div className="footer-company">
              <h5 className="footer-heading">Company</h5>
              <ul className="footer-links">
                <li>
                  <Link
                    to="/about-us"
                    onClick={() => {
                      if (window.location.pathname === "/about-us") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Our Story
                  </Link>
                </li>
                <li>
                  <Link
                    to="/sales-partners"
                    onClick={() => {
                      if (window.location.pathname === "/sales-partners") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Sales Partners
                  </Link>
                </li>

                <HashLink smooth to="/#services" className="nav-link mb-1">
                  Services
                </HashLink>
                <HashLink smooth to="/#quality" className="nav-link mb-1">
                  Quality
                </HashLink>

                <li>
                  <Link
                    to="/contact-us"
                    onClick={() => {
                      if (window.location.pathname === "/contact-us") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Contact Us
                  </Link>
                </li>

                {/* <li>
                  <Link
                    to="/careers"
                    onClick={() => {
                      if (window.location.pathname === "/careers") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Careers
                  </Link>
                </li> */}

                <li>
                  <Link
                    to="/news"
                    onClick={() => {
                      if (window.location.pathname === "/news") {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    News
                  </Link>
                </li>
              </ul>
            </div>

          </div>
          <div className='col-lg-2 col-md-3 col-6 d-flex justify-content-md-start justify-content-center'>
            <div className="footer-social">
              <h5 className="footer-heading">Social</h5>
              <ul className="footer-links">
                <li>
                  <a href="https://www.linkedin.com/company/premier-pumps/" target="_blank" rel="noopener noreferrer">
                    {/* <FaLinkedin className="linkedin-icon" /> */}
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-lg-2 col-md-3 col-6'>
            <div className="footer-legal">
              <h5 className="footer-heading">Legal</h5>
              <ul className="footer-links">
                <li><Link to="/terms">Terms</Link></li>
                <li><Link to="/privacy">Privacy</Link></li>
                {/* <li><Link to="/cookies">Cookies</Link></li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <hr />
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">

          <div className="row align-items-end">
            <div className="col-md-8 col-10 my-2">
              {/* Copyright Text */}
              <p className="text-sm mb-0">
                © 2025 PREMIER VACUUM SYSTEMS, All rights reserved. Unauthorized use prohibited.
              </p>
              <p className="text-sm mb-0">
                Developed by <a href="https://peracause.com/" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">PER A CAUSE</a>
              </p>
            </div>
            <div className="col-md-4 col-2 my-2">

              <div className="row justify-content-end">
                {/* Subscription Section */}
                {/* <div className="col-11 space-x-2 mt-4 md:mt-0">
                  <p className="text-sm">Subscribe News Letter</p>
                  <input
                    type="email"
                    placeholder="Your email..."
                    className="px-3 py-2 rounded bg-transparent border border-gray-500 text-white text-sm w-lg-60 w-50"
                  />
                  <button className="px-4 py-2 bg-gray text-black rounded text-sm border-0 ms-2">
                    Subscribe
                  </button>
                </div> */}

                {/* Social Icon */}
                <div className="col-md-1 col-4 mt-4 md:mt-0 footer-links d-flex align-items-end">
                  <a href="https://www.linkedin.com/company/premier-pumps/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin className="linkedin-icon fs-2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </footer >
  );
};

export default Footer;
